export const CHILD_OF_ALUMNI_OPTIONS = [
  { id: 0, value: 'No' },
  { id: 1, value: 'Si' },
  { id: 2, value: 'Pendiente' },
  { id: 3, value: 'No' },
];

export const STUDENT_STATUS = {
  NEW_ENTRY: 1,
  TRANSFER: 2,
  REENTRY: 3,
};
